import { useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import { SectionHeading, TableCustom, WrapperAdvancedSearch, FooterButtonVolver } from "../../components/common"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import { APIS } from "../../config/apis"
import { OPERATION_MODE, REQUEST_METHOD } from '@laramie/ui';
import { PERMISSIONS } from "../../consts/permissions"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { ServerRequest } from "../../utils/apiweb"
import CategoriaUbicacionModal from "../../components/controls/CategoriaUbicacionModal"
import { useSearchParams } from "react-router-dom"

const CategoriasUbicacionesView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    const [categorias, setCategorias] = useState([])
    const [editMode, setEditMode] = useState()
    const [editItem, setEditItem] = useState()
    const [tableVisible, setTableVisible] = useState(false)

    const searchRef = useRef()
    
    const { hasPermission } = usePermissions();
    const [search] = useSearchParams();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);
    const isViewOnly = search.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = canEdit && !isViewOnly;

    const filterData = data => {
        const { codigo, nombre, regimenGeneral } = searchRef.current.filters

        let filtered = [...data]

        if (codigo !== '') filtered = filtered.filter(rubro => rubro.codigo.toLowerCase().includes(codigo.toLowerCase()))
        if (nombre !== '') filtered = filtered.filter(rubro => rubro.nombre.toLowerCase().includes(nombre.toLowerCase()))

        return filtered
    }

    const SearchCategoriasUbicaciones = () => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CATEGORIA_UBICACION,
            null,
            null,
            res => res.json().then(data => {
                setCategorias(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = id => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.CATEGORIA_UBICACION,
            `/${id}`,
            null,
            () => {
                SearchCategoriasUbicaciones()
                setIsLoading(false)
            },
            () => {
                onRequestNoSuccess()
                setIsLoading(false)
            },
            () => {
                onRequestError()
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                nombre: '',
                orden: '',
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el registro?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    const onEditConfirm = () => {
        if (tableVisible) SearchCategoriasUbicaciones()
        else {
            setEditMode(null)
            setEditItem(null)
        }
    }

    const onEditCancel = () => {
        setEditMode(null)
        setEditItem(null)
    }

    return <>
        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Categorías de ubicaciones' }]}
                        onAddClick={allowEditActions ? avmr.onAdd : null} tableVisible={tableVisible}/>

        <section className='section-accordion'>

            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 6 },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 6 },
                ]}
                onSearch={SearchCategoriasUbicaciones}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={categorias}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    disabled={!allowEditActions}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '20%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '20%', },
                    ]}
                />
            )}

            {editItem && (
                <CategoriaUbicacionModal
                    item={editItem}
                    editMode={editMode}
                    onConfirm={onEditConfirm}
                    onCancel={onEditCancel}
                />
            )}
        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
    </>
}

export default CategoriasUbicacionesView
